import Form from "./Form";
import React from "react";
import { useAppContext } from "./AppContext";
import { useBrand } from "./BrandContext";
import { useTakebackConfig } from "./TakebackConfigContext";

function InstoreDetailsForm() {
  const {
    userDetails,
    setUserDetails,
    userDetailsHasErrors,
    setUserDetailsHasErrors,
    createInstoreTakebackError,
    setCreateInstoreTakebackError,
    instoreTakebackMutationLoading,
    instoreTakebackId,
    handleSubmitInstoreTakeback,
  } = useAppContext();

  const { storeApprovalRequired, tsAndCsLabelOverride, emailInputLabel } =
    useTakebackConfig();
  const { name } = useBrand();

  const handleChange = (newValue) => {
    const updatedDetailsForm = { ...userDetails, ...newValue };
    setUserDetails(updatedDetailsForm);
    setUserDetailsHasErrors(false);
    setCreateInstoreTakebackError(false);
  };

  let baseFormFields = [];
  if (storeApprovalRequired) {
    baseFormFields = [];
  } else {
    baseFormFields = [
      {
        name: "storeId",
        type: "store_finder",
        label:
          "Choose a store by using the find store button, or typing in the box above",
        placeholder: "Search by store name or city",
        error: userDetails.storeId.error,
      },
    ];
  }

  const formFields = [
    ...baseFormFields,
    {
      name: "email",
      value: userDetails.email.value,
      placeholder: "Enter email",
      type: "email",
      label:
        emailInputLabel ||
        "Enter your email so we know where to send your discount code.",
      autoComplete: "email",
      error: userDetails.email.error,
    },
    {
      type: "form_field_group",
      fields: [
        {
          name: "confirmEmail",
          value: userDetails.confirmEmail.value,
          placeholder: "Confirm email",
          type: "email",
          label: "So we know we've got the right address",
          autoComplete: "email",
          error: userDetails.confirmEmail.error,
        },
        {
          name: "optOutReskinned",
          value: userDetails.optOutReskinned.value,
          type: "checkbox",
          label: "Don't send me Reskinned updates and offers",
          error: userDetails.optOutReskinned.error,
        },
        {
          name: "optInBrand",
          value: userDetails.optInBrand.value,
          type: "checkbox",
          label: `Send me ${name} updates and offers`,
          error: userDetails.optInBrand.error,
        },
      ],
    },
    {
      name: "terms",
      value: userDetails.terms.value,
      type: "checkbox",
      label:
        tsAndCsLabelOverride ||
        "I accept the <a href='https://www.reskinned.clothing/pages/takeback/takeback-terms-and-conditions' target='_blank' style='text-decoration: underline;'>terms and conditions</a> and I acknowledge that I have read the <a href='https://www.reskinned.clothing/legal/privacy-cookie-policy' target='_blank'  style='text-decoration: underline;'>privacy policy.</a>",
      error: userDetails.terms.error,
    },
  ];

  let error = null;
  if (createInstoreTakebackError)
    error = "Something went wrong, instore takeback could not be created";
  if (userDetailsHasErrors)
    error = "Could not submit, please check the form above";

  return (
    <Form
      fields={formFields}
      handleChange={handleChange}
      handleSubmit={handleSubmitInstoreTakeback}
      error={error}
      submitting={instoreTakebackMutationLoading || instoreTakebackId !== null}
    />
  );
}

export default InstoreDetailsForm;
